import {ParaBirimiEntity} from "@/entity/ParaBirimiEntity";

export class TakipTarihliKurEntity{
    id!: number;
    para_birimi_id!: number;
    para_birimi!: ParaBirimiEntity;
    tutar!: number|null;
    tarih!: Date;
}